export var ExchangeModeEnum;
(function (ExchangeModeEnum) {
    ExchangeModeEnum["CONVERT"] = "CONVERT";
    ExchangeModeEnum["SWAP"] = "SWAP";
    ExchangeModeEnum["DIRECT_CRYPTO"] = "DIRECT_CRYPTO";
})(ExchangeModeEnum || (ExchangeModeEnum = {}));
//# sourceMappingURL=exchange-mode.enum.js.map